import React, { useState, useContext, useEffect } from 'react';
import AdminMasterLayout from '../../../layouts/Admin/AdminMasterLayout';
import { Container, Row, Col, Card, Table, Badge, Modal, Button } from 'react-bootstrap';
import { FaUser, FaCar, FaMapMarkerAlt, FaDollarSign, FaEye, FaTimes, FaClock } from 'react-icons/fa';
import '../../../assets/css/Admin/OngoingOrders/OngoingOrders.css';
import axios from 'axios';
import AppContext from '../../../context/AppContext';

const OngoingOrders = () => {
  const { baseUrl, authToken } = useContext(AppContext);
  const [ongoingRides, setOngoingRides] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedRide, setSelectedRide] = useState(null);

  const handleViewDetails = (ride) => {
    setSelectedRide(ride);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedRide(null);
  };

  useEffect(() => {
    axios.post(`${baseUrl}/admin/orders/viewOngoingOrders`, {}, {
        headers: { Authorization: `Bearer ${authToken}` },
    }).then((response) => {
        if (response.data.success === true) {
            setOngoingRides(response.data.rides);
        }
    }).catch((error) => console.log(error));
  }, []);

  return (
    <AdminMasterLayout screenName="ongoing">
      <Container fluid>
        <h2 className="ongoing-orders-title">Ongoing Orders</h2>

        <Row>
          <Col lg={12}>
            <Card className="ongoing-orders-card">
              <Card.Body>
                <div className="ongoing-orders-table-wrapper">
                  <Table responsive className="ongoing-orders-table">
                    <thead>
                      <tr>
                        <th>Ride ID</th>
                        <th>Customer Details</th>
                        <th>Driver Details</th>
                        <th>Ride Details</th>
                        <th>Fare & Payment</th>
                        <th>Status</th>
                        <th>Booking Date</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ongoingRides.length > 0 ? ongoingRides.map((ride) => (
                        <tr key={ride.id}>
                          <td><strong className="ongoing-orders-ride-id">{ride.id}</strong></td>

                          <td>
                            <div className="ongoing-orders-customer-info">
                              <div className="ongoing-orders-info-icon"><FaUser /></div>
                              <div>
                                <strong>{ride.tdcustomer?.customerName}</strong>
                                <p className="ongoing-orders-detail">{ride.tdcustomer?.mobileNumber}</p>
                                <p className="ongoing-orders-detail">{ride.tdcustomer?.customerEmail}</p>
                              </div>
                            </div>
                          </td>

                          <td>
                            <div className="ongoing-orders-driver-info">
                              <div className="ongoing-orders-info-icon driver"><FaCar /></div>
                              <div>
                                <strong>{ride.tddriver?.drivername}</strong>
                                <p className="ongoing-orders-detail">ID: {ride.tddriver?.id}</p>
                                <p className="ongoing-orders-detail">{ride.tddriver?.driverphone}</p>
                              </div>
                            </div>
                          </td>

                          <td>
                            <div className="ongoing-orders-location-info">
                              <div className="ongoing-orders-location-item">
                                <FaMapMarkerAlt className="ongoing-orders-location-icon pickup" />
                                <div><small>Pickup</small><p>{ride.pickuplocation}</p></div>
                              </div>
                              <div className="ongoing-orders-location-item">
                                <FaMapMarkerAlt className="ongoing-orders-location-icon dropoff" />
                                <div><small>Drop-off</small><p>{ride.dropofflocation}</p></div>
                              </div>
                            </div>
                          </td>

                          <td>
                            <div className="ongoing-orders-fare-info">
                              <div className="ongoing-orders-fare-amount">
                                <FaDollarSign />
                                <strong>Rs. {ride.offeredFare}</strong>
                              </div>
                              <Badge
                                bg={ride.paymentmethod === 'cash' ? 'success' : 'info'}
                                className="ongoing-orders-payment-badge"
                              >
                                {ride.paymentmethod}
                              </Badge>
                            </div>
                          </td>

                          <td>
                            <Badge bg="primary" className="ongoing-orders-status-badge">
                              {ride.status}
                            </Badge>
                          </td>

                          <td>
                            <span className="ongoing-orders-date">{ride.bookingDate}</span>
                          </td>

                          <td>
                            <button className="ongoing-orders-view-btn" onClick={() => handleViewDetails(ride)}>
                              <FaEye /> View
                            </button>
                          </td>
                        </tr>
                      )) : (
                        <tr>
                          <td colSpan="8" className="text-center">No ongoing rides found</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
          <Modal.Header closeButton className="ongoing-orders-modal-header">
            <Modal.Title>Ride Details - {selectedRide?.id}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="ongoing-orders-modal-body">
            {selectedRide && (
              <Row>
                <Col md={6} className="mb-4">
                  <Card className="ongoing-orders-detail-card">
                    <Card.Body>
                      <h6 className="ongoing-orders-section-title"><FaUser /> Customer Information</h6>
                      <div className="ongoing-orders-detail-item"><strong>Name:</strong> {selectedRide.tdcustomer?.customerName}</div>
                      <div className="ongoing-orders-detail-item"><strong>Phone:</strong> {selectedRide.tdcustomer?.mobileNumber}</div>
                      <div className="ongoing-orders-detail-item"><strong>Email:</strong> {selectedRide.tdcustomer?.customerEmail}</div>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={6} className="mb-4">
                  <Card className="ongoing-orders-detail-card">
                    <Card.Body>
                      <h6 className="ongoing-orders-section-title"><FaCar /> Driver Information</h6>
                      <div className="ongoing-orders-detail-item"><strong>Name:</strong> {selectedRide.tddriver?.drivername}</div>
                      <div className="ongoing-orders-detail-item"><strong>Driver ID:</strong> {selectedRide.tddriver?.id}</div>
                      <div className="ongoing-orders-detail-item"><strong>Phone:</strong> {selectedRide.tddriver?.driverphone}</div>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={12} className="mb-4">
                  <Card className="ongoing-orders-detail-card">
                    <Card.Body>
                      <h6 className="ongoing-orders-section-title"><FaMapMarkerAlt /> Ride Information</h6>
                      <Row>
                        <Col md={6}>
                          <div className="ongoing-orders-detail-item"><strong>Pickup:</strong> {selectedRide.pickuplocation}</div>
                          <div className="ongoing-orders-detail-item"><strong>Drop-off:</strong> {selectedRide.dropofflocation}</div>
                        </Col>
                        <Col md={6}>
                          <div className="ongoing-orders-detail-item"><strong>Vehicle Type:</strong> {selectedRide.vehicleType}</div>
                          <div className="ongoing-orders-detail-item"><strong>Booking Type:</strong> {selectedRide.bookingType}</div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={12} className="mb-4">
                  <Card className="ongoing-orders-detail-card">
                    <Card.Body>
                      <h6 className="ongoing-orders-section-title"><FaDollarSign /> Payment Details</h6>
                      <div className="ongoing-orders-detail-item"><strong>Total Fare:</strong> Rs. {selectedRide.offeredFare}</div>
                      <div className="ongoing-orders-detail-item">
                        <strong>Payment Method:</strong>{' '}
                        <Badge bg={selectedRide.paymentmethod === 'cash' ? 'success' : 'info'}>
                          {selectedRide.paymentmethod}
                        </Badge>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={12}>
                  <Card className="ongoing-orders-detail-card">
                    <Card.Body>
                      <h6 className="ongoing-orders-section-title"><FaClock /> Booking Information</h6>
                      <div className="ongoing-orders-detail-item"><strong>Booking Date:</strong> {selectedRide.bookingDate}</div>
                      <div className="ongoing-orders-detail-item"><strong>Booking Time:</strong> {selectedRide.bookingTime}</div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              <FaTimes /> Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </AdminMasterLayout>
  );
};

export default OngoingOrders;